import { EbLanguageEffects } from './eb-language.effect'

export const effects = [EbLanguageEffects]

export * from './eb-language.effect'
